import { workdayMaskToIsoDays } from '../workday-mask';
import type { EmploymentWeekdayDetails } from './employment.model';

export function weekdayDetailsFromMask(mask: number): EmploymentWeekdayDetails[] {
  return workdayMaskToIsoDays(mask).map(weekday => ({ weekday }));
}
